export class ResizeUtils {
    private resizeListener: () => void = () => {};
    private debounceTimer: any;
    private handleGridSizeChangeCallback: (columns: number, rows: number, totalApps: number) => void;

    constructor(handleGridSizeChangeCallback: (columns: number, rows: number, totalApps: number) => void) {
        this.handleGridSizeChangeCallback = handleGridSizeChangeCallback;
    }

    /**
     * @description Configura el listener de resize
     */
    setupResizeListener(): void {
        this.resizeListener = () => {
            // Usar un debounce para evitar ejecuciones excesivas
            this.debounceResize();
        };

        window.addEventListener('resize', this.resizeListener);
    }

    /**
     * @description Remueve el listener de resize
     */
    removeResizeListener(): void {
        if (this.resizeListener) {
            window.removeEventListener('resize', this.resizeListener);
        }
    }

    /**
     * @description Debounce para el resize - evita ejecuciones excesivas
     */
    private debounceResize(): void {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            this.getColumnsInfo();
        }, 0);
    }

    /**
     * @description Obtiene columnas y filas de miniaturas usando Angular
     */
    getColumnsInfo(): void {
        const mainDataElem = document.getElementById('container_apps');
        if (!mainDataElem) {
            console.warn('Elemento #container_apps no encontrado, reintentando...');
            setTimeout(() => this.getColumnsInfo(), 0);
            return;
        }

        const style = window.getComputedStyle(mainDataElem);
        const gridTemplateColumns = style.gridTemplateColumns.trim();

        if (!gridTemplateColumns || gridTemplateColumns === 'none') {
            console.warn('No se pudo calcular grid-template-columns todavía, reintentando...');
            setTimeout(() => this.getColumnsInfo(), 0);
            return;
        }

        const columns = gridTemplateColumns.split(' ').length;
        const rows = 2; // Asumes por diseño cuántas filas quieres visibles
        const totalApps = columns * rows;

        //console.debug(`✅ Grid listo - columns: ${columns}, rows: ${rows}, total apps visibles: ${totalApps}`);
        //console.debug(`🧠 CSS leído: '${gridTemplateColumns}'`);

        this.handleGridSizeChange(columns, rows, totalApps);
    }

    /**
     * @description Maneja los cambios de tamaño del grid
     * @param columns Número de columnas
     * @param rows Número de filas
     * @param totalApps Total de aplicaciones visibles
     */
    private handleGridSizeChange(columns: number, rows: number, totalApps: number): void {
        // Validar que los valores sean válidos
        if (columns <= 0 || rows <= 0 || totalApps <= 0) {
            console.warn('Valores de grid inválidos:', { columns, rows, totalApps });
            return;
        }

        // Llamar al callback del componente
        this.handleGridSizeChangeCallback(columns, rows, totalApps);
    }

    destroy(): void {
        this.removeResizeListener();
        clearTimeout(this.debounceTimer);
    }
}
